import gateway from "@interceptors/gateway.interceptor"
import { BaseService } from "./base.service"

class CardLocationService extends BaseService{
    
    public updateLocationCard = async (id: string, body: any) => {
        const url = `/location/update/${id}`
        const response = await gateway.put(url,body);
        return response.data;
    } 

    public getLocationByAccomodationId = async (id: number)=>{
        const url = `location/find-by-accomodation-id/${id}`;
        const response = await gateway.get(url)
        return response.data;
    }

}
export default new CardLocationService();
